module.exports = __webpack_public_path__ + "static/media/mon.2943ab6b.png";